export enum MONITORING_RESULT_REVIEWER_TYPE {
  AI = 'AI',
  FIRST_REVIEWER = 'First Reviewer',
  FINAL_REVIEWER = 'Final Reviewer',
  EDIT = 'Editor',
  REOPENED = 'Reopened',
}

export enum MONITORING_RESULT_CATEGORIZATION_TYPES {
  INITIAL = 'Initial',
  RENEWAL = 'Renewal',
  FIRST_RENEWAL = 'First Renewal',
  SECOND_RENEWAL = 'Second Renewal',
  ODD_RENEWAL = 'Odd Renewal',
  EVEN_RENEWAL = 'Even Renewal',
}

export enum MONITORING_RESULT_CATEGORIES {
  INSTRUCTION = 'Instruction',
  EDUCATION = 'Education',
  EXPERIENCE = 'Experience',
  CONTINUING_EDUCATION = 'Continuing Education',
  EXAM = 'Exam',
  FEES = 'Fees',
  TERM = 'Term',
  EXPIRATION_DATE = 'Expiration Date',
  BACKGROUND_CHECK = 'Background Check',
  REFERENCE = 'Reference',
}

export enum MONITORING_CLASSIFICATION {
  NO_CHANGE = 0,
  MINOR = 1,
  MAJOR = 2,
  CRITICAL = 3,
}

export enum MONITORING_RESULT_EDGE_STATUS {
  INIT = 'Init',
  REVIEW_READY = 'Review Ready',
  FIRST_REVIEWED = 'First Reviewed',
  PUBLISHED = 'Published',
  REOPENED = 'Reopened',
}

export enum MONITORING_PROGRESS_STAGE {
  FIRST_REVIEW = 1,
  FINAL_REVIEW = 2,
}

export const EDGE_STATUS_TO_PROGRESS_STAGE_MAPPING = {
  [MONITORING_RESULT_EDGE_STATUS.REVIEW_READY]: MONITORING_PROGRESS_STAGE.FIRST_REVIEW,
  [MONITORING_RESULT_EDGE_STATUS.FIRST_REVIEWED]: MONITORING_PROGRESS_STAGE.FINAL_REVIEW,
  [MONITORING_RESULT_EDGE_STATUS.REOPENED]: MONITORING_PROGRESS_STAGE.FINAL_REVIEW,
};

export const EDGE_STATUS_TO_REVIEWER_TYPE_MAPPING = {
  [MONITORING_RESULT_EDGE_STATUS.REVIEW_READY]: MONITORING_RESULT_REVIEWER_TYPE.FIRST_REVIEWER,
  [MONITORING_RESULT_EDGE_STATUS.FIRST_REVIEWED]: MONITORING_RESULT_REVIEWER_TYPE.FINAL_REVIEWER,
  [MONITORING_RESULT_EDGE_STATUS.REOPENED]: MONITORING_RESULT_REVIEWER_TYPE.FINAL_REVIEWER,
};
